module.exports = __webpack_public_path__ + "static/media/salisbury-8.be027592.jpg";